import { render } from "./UserSettingBlock.vue?vue&type=template&id=7327c80b&scoped=true"
import script from "./UserSettingBlock.vue?vue&type=script&lang=js"
export * from "./UserSettingBlock.vue?vue&type=script&lang=js"

import "./UserSettingBlock.vue?vue&type=style&index=0&id=7327c80b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7327c80b"]])

export default __exports__